import React, { useEffect, useState, useMemo, useContext } from "react";
import {
  Modal,
  Checkbox,
  Input,
  Divider,
  Button,
  Tooltip,
  Row,
  Col,
} from "antd";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import defaultLogo from "../../assets/images/default_company_logo.jpg";
import tag from "../../assets/svg/tag.svg";
import pdf from "../../assets/svg/pdf.svg";
import industry from "../../assets/svg/industry.svg";
import employees from "../../assets/svg/employees.svg";
import phone from "../../assets/svg/phone.svg";
import website from "../../assets/svg/website.svg";
import {
  submitErrorForm,
  createCompanyTag,
  emptyErrorObj,
  getCompanyTag,
  resetCreatedTag,
  resetCompanyTag,
} from "../../actionCreator/companyDetailsActionCreator";
import { emailRegex, subscriptionContentInfo } from "../../config";
import {
  getSubscriptionUserInfo,
  getUserInfo,
  getPartialPhoneNumber,
} from "../../utils/utils";
import TrialModal from "../../common/TrialModal";
import popupImg from "../../assets/images/free-user-login-prompt.jpg.jpeg";
import subscribepopupImg from "../../assets/images/subscribe-now-prompt-img.jpg";
import { AuthContext } from "../../context/AuthContext";
import TruncateTest from "../../common/TruncateTest";

const SummaryHeader = ({ downloadPDFCallback }) => {
  const [showModal, setShowModal] = useState(false);
  const [openModal, setOpenModal] = useState({
    info: null,
    open: false,
  });
  const formIntialValue = {
    telephone: { disabled: true, value: "", status: null },
    address: { disabled: true, value: "", status: null },
    city: { disabled: true, value: "", status: null },
    zip: { disabled: true, value: "", status: null },
    employee: { disabled: true, value: "", status: null },
    website: { disabled: true, value: "", status: null },
    name: { disabled: true, value: "", status: null },
    email: { disabled: true, value: "", status: null },
    comment: { disabled: true, value: "", status: null },
  };

  const dispatch = useDispatch();
  const { isAuthenticated } = useContext(AuthContext);
  const { TextArea } = Input;
  const [openErrorForm, setOpenErrorForm] = useState(false);
  const [isApiFailed, setIsApiFailed] = useState(false);
  const [openTagModal, setOpenTagModal] = useState(false);
  const [tagValues, setTagValues] = useState({
    tagname: "",
    description: "",
    tagError: "",
  });
  const [errorForm, setErrorForm] = useState(formIntialValue);
  const companyDetails = useSelector(
    (state) => state.companyDetailsReducer.companyDetails
  );
  const navigate = useNavigate();
  const errObj = useSelector((state) => state.companyDetailsReducer.errObj);
  const fetchCompanyTag = useSelector(
    (state) => state.companyDetailsReducer.fetchCompanyTag
  );
  const sigleCompanyTag = useSelector(
    (state) => state.companyDetailsReducer.sigleCompanyTag
  );

  const userAccountInfo = useSelector(
    (state) => state.CommonReducer.accountInfo
  );

  const [taggedCompany, setTaggedCompany] = useState(false);
  const [taggedCompanySuccess, setTaggedCompanySuccess] = useState(false);
  useEffect(() => {
    if (Object.keys(errObj).length) {
      setIsApiFailed(true);
    }
    if (!Object.keys(errObj).length) {
      setIsApiFailed(false);
    }
  }, [Object.keys(errObj).length]);

  useMemo(() => {
    if (Object.keys(getUserInfo()).length && companyDetails?.id) {
      const { id } = getUserInfo();
      dispatch(resetCompanyTag());
      dispatch(getCompanyTag(companyDetails?.id, id));
    }
  }, [companyDetails, userAccountInfo]);

  useEffect(() => {
    if (fetchCompanyTag.length) {
      setTaggedCompany(true);
    } else {
      setTaggedCompany(false);
    }
  }, [fetchCompanyTag]);

  useEffect(() => {
    if (Object.keys(sigleCompanyTag).length) {
      setTaggedCompanySuccess(true);
    }
  }, [sigleCompanyTag]);

  const closeErrorForm = () => {
    setOpenErrorForm(false);
    setErrorForm(formIntialValue);
  };

  const enableField = (ele) => {
    setErrorForm({
      ...errorForm,
      [ele.target.name]: ele.target.checked
        ? { ...errorForm[ele.target.name], disabled: !ele.target.checked }
        : { value: "", disabled: !ele.target.checked },
    });
  };

  const onInputChange = (ele) => {
    setErrorForm({
      ...errorForm,
      [ele.target.name]: {
        ...errorForm[ele.target.name],
        value: ele.target.value,
        status: null,
      },
    });
  };

  const onSubmitForm = () => {
    const regEx = new RegExp(emailRegex);
    const clone = _.cloneDeep(errorForm);
    if (!errorForm?.name?.value) {
      clone.name.status = "error";
      setErrorForm(clone);
      return false;
    }

    if (!errorForm?.email?.value || !regEx.test(errorForm?.email?.value)) {
      clone.email.status = "error";
      setErrorForm(clone);
      return false;
    }

    let newPayload = {};
    Object.keys(errorForm).forEach((key) => {
      newPayload = {
        ...newPayload,
        [key]: errorForm[key].value,
      };
    });
    const { id } = getUserInfo();
    const { id: accountId } = getSubscriptionUserInfo();
    const payload = {
      accountId: accountId,
      companyId: companyDetails?.id,
      description: newPayload,
      iscompany: true,
      iscorrected: true,
      userId: id,
    };
    dispatch(submitErrorForm(payload));
    setOpenErrorForm(false);
    setErrorForm(formIntialValue);
  };

  const checkLoginStatus = () => {
    let isLoggedIn = false;
    if (isAuthenticated) {
      setShowModal(false);
      isLoggedIn = true;
    } else {
      setShowModal(true);
      isLoggedIn = false;
    }
    return isLoggedIn;
  };

  const onConfrim = () => {
    if (!tagValues.tagname) {
      setTagValues({
        ...tagValues,
        tagError: "error",
      });
    } else {
      const { id } = getUserInfo();
      const payload = {
        company: companyDetails,
        text: tagValues.tagname,
        userId: id,
      };
      dispatch(createCompanyTag(payload));
      setOpenTagModal(false);
    }
  };

  const onTagInputChange = (e) => {
    setTagValues({
      ...tagValues,
      [e.target.name]: e.target.value,
    });
  };

  const tagCompany = () => {
    const isLoggedIn = checkLoginStatus();
    if (isLoggedIn) {
      setOpenTagModal(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setOpenModal(false);
    dispatch(emptyErrorObj());
  };

  const redirectToSignup = () => {
    setShowModal(false);
    navigate("/signup");
  };

  const closeTagModal = () => {
    setOpenTagModal(false);
  };
  const closeCompanySuccessModal = () => {
    setTaggedCompanySuccess(false);
    dispatch(resetCreatedTag());
  };
  return (
    <div className=" navbar-light mrgn mt-4" id="onScroll">
      <div className="common-box-2 roboto-regular">
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-center" style={{ gap: 20 }}>
            <img
              alt="Company Logo"
              src={companyDetails?.companyLogoUrl || defaultLogo}
              onError={(e) => {
                e.currentTarget.src = defaultLogo;
              }}
              className="company-logo"
            />

            <div>
              {!!companyDetails?.name && (
                <h3 className="heading18px fw-bold">{companyDetails?.name}</h3>
              )}
              {!!companyDetails?.address && (
                <div className="heading13px">{companyDetails?.address}</div>
              )}
            </div>
          </div>
          <div className="d-flex gap-20">
            <Tooltip title="Tag Company">
              <img
                src={tag}
                alt=""
                className="w-20 h-20 cursor-pointer"
                onClick={tagCompany}
              />
            </Tooltip>

            <Tooltip title="Download PDF">
              <img
                src={pdf}
                alt=""
                className="w-20 h-20 cursor-pointer"
                onClick={() => downloadPDFCallback(companyDetails?.id)}
              />
            </Tooltip>
          </div>
        </div>
        <div>
          <Row
            gutter={[{ xs: 16 }, { xs: 16, md: 24, lg: 32 }]}
            className="mt30 mb30 align-items-center justify-content-between heading13px"
          >
            {!!companyDetails?.industry?.name && (
              <Col xs={16} xl={5} className="d-flex gap-10">
                <img src={industry} alt="" className="w-20 h-20" />
                <div className="d-flex flex-column">
                  <span className="fw-bold leading13">Industry</span>
                  <span className="mt5">{companyDetails?.industry?.name}</span>
                </div>
              </Col>
            )}
            {!!companyDetails?.range?.name && (
              <>
                <Col xs={0} xl={1}>
                  <div className="vertical-line"></div>
                </Col>
                <Col xs={16} xl={5} className="d-flex gap-10">
                  <img src={employees} alt="" className="w-20 h-20" />
                  <div className="d-flex flex-column">
                    <span className="fw-bold leading13">Employees</span>
                    <span className="mt5">{companyDetails?.range?.name}</span>
                  </div>
                </Col>
              </>
            )}
            {!!companyDetails?.phoneNo && (
              <>
                <Col xs={0} xl={1}>
                  <div className="vertical-line"></div>
                </Col>
                <Col xs={16} xl={5} className="d-flex gap-10">
                  <img src={phone} alt="" className="w-20 h-20" />
                  <div className="d-flex flex-column">
                    <span className="fw-bold leading13">Phone</span>
                    <span className="mt5">
                      {getPartialPhoneNumber(companyDetails?.phoneNo)}
                    </span>
                  </div>
                </Col>
              </>
            )}
            {!!companyDetails?.wedsite && (
              <>
                <Col xs={0} xl={1}>
                  <div className="vertical-line"></div>
                </Col>
                <Col xs={16} xl={5} className="d-flex gap-10">
                  <img src={website} alt="" className="w-20 h-20" />
                  <div className="d-flex flex-column">
                    <span className="fw-bold leading13">Website</span>
                    <Link
                      className="font-weight-normal mt5 text-dark word-break-all heading13px"
                      to={`http://${companyDetails?.wedsite}`}
                      target="_blank"
                    >
                      {companyDetails?.wedsite}
                    </Link>
                  </div>
                </Col>
              </>
            )}
          </Row>

          <TruncateTest description={companyDetails?.introduction} />
        </div>
      </div>

      {openErrorForm && (
        <Modal
          title={
            <div className="errorformcontainertitle">
              <h4>Report an Error</h4>
              <h2>Report Incorrect Information</h2>
            </div>
          }
          okText="Submit"
          cancelText="Cancel"
          width="450px"
          open={openErrorForm}
          onOk={onSubmitForm}
          onCancel={closeErrorForm}
        >
          <div className="errorformcontainer">
            <p>
              Please select the appropriate checkbox that you have found
              Incorrect and if you know the correct data please provide us in
              appropriate text box.
            </p>
            <div className="form">
              <div className="formcol1">
                <Checkbox name="telephone" onChange={enableField}>
                  Telephone
                </Checkbox>
              </div>
              <div className="formcol2">
                <Input
                  name="telephone"
                  value={errorForm?.telephone?.value}
                  placeholder="Telephone"
                  disabled={errorForm?.telephone?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="form">
              <div className="formcol1">
                <Checkbox name="address" onChange={enableField}>
                  Address
                </Checkbox>
              </div>
              <div className="formcol2">
                <TextArea
                  name="address"
                  value={errorForm?.address?.value}
                  rows={2}
                  maxLength={100}
                  disabled={errorForm?.address?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="form">
              <div className="formcol1">
                <Checkbox name="city" onChange={enableField}>
                  City
                </Checkbox>
              </div>
              <div className="formcol2">
                <Input
                  name="city"
                  value={errorForm?.city?.value}
                  placeholder="City"
                  disabled={errorForm?.city?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="form">
              <div className="formcol1">
                <Checkbox name="zip" onChange={enableField}>
                  Zip/Pin code
                </Checkbox>
              </div>
              <div className="formcol2">
                <Input
                  name="zip"
                  value={errorForm?.zip?.value}
                  placeholder="Zip/Pin code"
                  disabled={errorForm?.zip?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="form">
              <div className="formcol1">
                <Checkbox name="employee" onChange={enableField}>
                  No. of Employees
                </Checkbox>
              </div>
              <div className="formcol2">
                <Input
                  name="employee"
                  value={errorForm?.employee?.value}
                  placeholder="No. of Employees"
                  disabled={errorForm?.employee?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <div className="form">
              <div className="formcol1">
                <Checkbox name="website" onChange={enableField}>
                  Website
                </Checkbox>
              </div>
              <div className="formcol2">
                <Input
                  name="website"
                  value={errorForm?.website?.value}
                  placeholder="Website"
                  disabled={errorForm?.website?.disabled}
                  onChange={onInputChange}
                />
              </div>
            </div>

            <Divider dashed={true} />

            <div className="formfull">
              <Input
                name="name"
                status={errorForm?.name?.status}
                value={errorForm?.name?.value}
                placeholder="Your Name*"
                onChange={onInputChange}
              />
            </div>

            <div className="formfull">
              <Input
                name="email"
                status={errorForm?.email?.status}
                value={errorForm?.email?.value}
                placeholder="Your Email ID*"
                onChange={onInputChange}
              />
            </div>

            <div className="formfull">
              <TextArea
                name="comment"
                value={errorForm?.comment?.value}
                rows={3}
                maxLength={100}
                placeholder="Comment if any"
                onChange={onInputChange}
              />
            </div>
          </div>
        </Modal>
      )}

      {showModal ? (
        <TrialModal
          openModal={showModal}
          closeModal={closeModal}
          redirectToSignup={redirectToSignup}
          redirect={true}
          buttonText="Start Free Trial"
          modalBody={
            <div id="small-dialog2">
              <div align="center">
                <img src={popupImg} alt="" />
              </div>
              <p style={{ color: "#0000FF" }}>
                Get 10 free verified contacts with a BeyondLeadz Pro trial
              </p>
              <p>
                BeyondLeadz Pro customers close deals faster thanks to relevant
              </p>
            </div>
          }
          modalWidth="400px"
        />
      ) : (
        ""
      )}
      {openModal?.open && (
        <TrialModal
          openModal={openModal}
          closeModal={closeModal}
          redirectToSignup={redirectToSignup}
          redirect={true}
          buttonText={subscriptionContentInfo.btntext}
          modalBody={
            <div id="small-dialog2">
              <div align="center">
                <img src={subscribepopupImg} alt="" />
              </div>
              <p style={{ color: "#0000FF" }}>
                {subscriptionContentInfo.content}
              </p>
            </div>
          }
          modalWidth="400px"
        />
      )}

      {isApiFailed ? (
        <TrialModal
          openModal={isApiFailed}
          closeModal={closeModal}
          redirectToSignup={redirectToSignup}
          buttonText="OK"
          modalBody={
            <div id="small-dialog2">
              Please call System support. You application having some issue.
            </div>
          }
          modalWidth="400px"
        />
      ) : (
        ""
      )}

      {taggedCompanySuccess ? (
        <Modal
          title=""
          width={"400px"}
          closable={true}
          open={taggedCompanySuccess}
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={closeCompanySuccessModal}
            >
              OK
            </Button>,
          ]}
        >
          <div className="pop-up errorformcontainer ">
            <p>Tag created!</p>
          </div>
        </Modal>
      ) : (
        ""
      )}

      {openTagModal ? (
        <Modal
          title="Tag Company"
          width={"400px"}
          closable={true}
          open={openTagModal}
          onCancel={closeTagModal}
          onOk={onConfrim}
        >
          {taggedCompany ? (
            <div className="pop-up errorformcontainer ">
              <p>Already Tagged!</p>
            </div>
          ) : (
            ""
          )}
          <div className="pop-up errorformcontainer ">
            <div className="form">
              <div className="formcol1">
                <label>Tag Name</label>
              </div>
              <div className="formcol2">
                <Input
                  name="tagname"
                  status={tagValues?.tagError}
                  value={tagValues.tagname}
                  placeholder="Tag Name"
                  onChange={onTagInputChange}
                />
              </div>
            </div>
          </div>
        </Modal>
      ) : (
        ""
      )}
    </div>
  );
};

export default SummaryHeader;
